package org.dronda.application.config

import kotlin.String

internal object BuildKonfig {
  public val appUrl: String = "https://app.dronda.org"

  public val apiUrl: String = "https://plm.dronda.org"

  public val clientId: String = "Ijownovx7Xnp7M10vE1FIjIc8"
}
